import { RecentEscalationResponse } from '@hakimo-ui/hakimo/types';
import useAuthenticatedRequest from '../shared/useAuthenticatedRequest';

export function useLastEscalation(locationId: string) {
  const url = `/v2/orm/locations/${locationId}/recent-escalations`;
  const request = new Request(url);

  return useAuthenticatedRequest<RecentEscalationResponse>(request, {
    queryKey: ['recent_escalation', locationId],
    enabled: !!locationId,
    refetchInterval: 60000,
    responseModifier: async (response) => {
      const respJson = await response.json();
      return respJson.payload;
    },
  });
}
